const removeChildNodes = (elem) => {
    elem?.replaceChildren();
};

export {
    removeChildNodes
}